import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReportesModel from './reportes.model';

export const selectCorreoState = createFeatureSelector<fromReportesModel.ReportesState>(
  fromReportesModel.reportesFeatureKey
);

export const selectInformacionCorreo = createSelector(
  selectCorreoState,
  (state: fromReportesModel.ReportesState) => state.programacion);



